import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Button, Table, Input, Form, FormFeedback, FormGroup, FormText } from 'reactstrap';
import moment from 'moment';
import { connect } from 'react-redux';

class Template extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templateData: [],
            daySelect: [],
            addError: false,
            badTime: false,
            badTimeRecord: "",
            badDate: false,
            badDateRecord: "",
            newKey: 1
        }
        this.getTemplate();
    }

    getTemplate() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            semester: this.props.activeTerm
        }
        fetch('GetTemplateData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
            .then((response) => response.json())
            .then((responseJSON) => { this.templateSet(responseJSON); })
        fetch('GetTemplateDays', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify({ userLevel: this.props.reduxData.userInfo.level.pk })
        })
            .then((response) => response.json())
            .then((responseJSON) => { this.daySet(responseJSON); })
        //localStorage.setItem("lastFetch", moment());
    }

    templateSet(input) {
        this.setState({
            templateData: input
        })
    }

    daySet(input) {
        this.setState({
            daySelect: input
        })
    }

    componentDidMount() {

    }

    async addRecord(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        if (dataInput.get('datesched') == null || dataInput.get('timesched') == "") {
            //console.log("returning")
            this.setState({
                addError: true
            })
            return;
        }
        //console.log("add record: " + dataInput.get('datesched') + ", " + dataInput.get('timesched'));
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            datesched: dataInput.get('datesched'),
            timesched: dataInput.get('timesched'),
            semester: this.props.activeTerm
        }
        const response = await fetch('AddExamTemplate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            templateData: data,
            newKey: this.state.newKey + 1
        })
        this.props.recheckLock();
    }

    async deleteRecord(pk) {
        //console.log("delete: " + pk);
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            targetpk: pk,
            semester: this.props.activeTerm
        }
        const response = await fetch('DeleteExamTemplate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            templateData: data,
            newKey: this.state.newKey + 1
        })
        this.props.recheckLock();
    }

    async changeValue(pk, input, field) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.setState({
            badDate: false,
            badDateRecord: ""
        })
        //console.log("changing: " + pk + ", " + input + ", " + field)
        if (field == "DATE" && input.length > 10) {
            this.setState({
                badDate: true,
                badDateRecord: pk
            })
            this.getTemplate();
        }
        else {
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                targetpk: pk,
                newvalue: input,
                updatetype: field,
                semester: this.props.activeTerm
            }
            const response = await fetch('UpdateExamTemplate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            this.setState({
                templateData: data,
                newKey: this.state.newKey + 1
            })
            if (field == "DATE") {
                this.props.recheckLock();
            }
        }
        //localStorage.setItem("lastFetch", moment());
        setTimeout(() => {
            this.setState({
                badDate: false,
                badDateRecord: ""
            })
        }, 6000)
    }

    checkTimeIssue(starttime, endtime, pk, type) {

        let newData
        if (type == "START") newData = starttime; else newData = endtime;
        this.changeValue(pk, newData, type);
        if (starttime > endtime) {
            this.setState({
                badTime: true,
                badTimeRecord: pk
            })
            setTimeout(() => {
                this.setState({
                    badTime: false,
                    badTimeRecord: ""
                })
            }, 6000)
        }
        
    }

    render() {
        return (
            <div key={this.state.newKey}>
                <Form inline className="d-flex" onSubmit={this.addRecord.bind(this)} style={{ visibility: !this.props.editLock ? 'visible' : 'hidden' }}>
                    <Input type="select" name="datesched" id="datesched" defaultValue="DEFAULT">
                        <option disabled value="DEFAULT">Select Day...</option>
                        {this.state.daySelect.map(item => (
                            <option value={item.daycode}>{item.daytext}</option>
                            )) }
                    </Input>
                    &nbsp;
                    <Input type="time" name="timesched" id="timesched" />
                    &nbsp;
                    <Button outline color="success" type="submit">Add</Button>
                </Form>
                <br />
                <div><b>Please be aware: Once the Scheduler has been opened, all schedules will be created based on the patterns enumerated here. Be sure these patters are complete here before beginning to schedule.
                Once the Scheduler has been opened, edits made here will not affect the schedules in Scheduler.</b></div>
                <br />
                <div ><Table striped>
                    <thead>
                        <tr>
                            <th>Day Schedule</th>
                            <th>Event Start Time</th>
                            <th>Planned Exam Date</th>
                            <th>Planned Exam Start Time</th>
                            <th>Planned Exam End Time</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.templateData.map(item => (
                            <tr>
                                <td>{item.datesched}</td>
                                <td>{item.schedtimes}</td> 
                                <td>
                                    {this.props.editLock && <div>{item.examdate}</div> }
                                    {!this.props.editLock && <FormGroup>
                                        <Input
                                            type="date"
                                            name="date"
                                            id="date"
                                            invalid={this.state.badDate && this.state.badDateRecord == item.pk }
                                            defaultValue={item.examdate}
                                            onBlur={(e) => this.changeValue(item.pk, e.target.value, "DATE")} />
                                        <FormFeedback tooltip>Your date is invalid. Please re-enter the expected date.</FormFeedback>
                                        </FormGroup>}
                                </td>
                                <td>
                                    {this.props.editLock && <div>{item.examstart}</div> }
                                    {!this.props.editLock && <FormGroup><Input
                                        type="time"
                                        name="examstart"
                                        id="examstart"
                                        invalid={this.state.badTime && this.state.badTimeRecord == item.pk}
                                        defaultValue={item.examstart}
                                        onBlur={(e) => this.checkTimeIssue(e.target.value, item.examend, item.pk, "START")} />
                                        <FormFeedback tooltip>Your exam cannot start after it ends.</FormFeedback>
                                    </FormGroup>}
                                </td>
                                <td>
                                    {this.props.editLock && <div>{item.examend}</div> }
                                    {!this.props.editLock && <Input
                                        type="time"
                                        name="examend"
                                        id="examend"
                                        invalid={this.state.badTime && this.state.badTimeRecord == item.pk }
                                        defaultValue={item.examend}
                                        onBlur={(e) => this.checkTimeIssue(item.examstart, e.target.value, item.pk, "END")} />}
                                </td>
                                <td><Button style={{ visibility: !this.props.editLock ? 'visible' : 'hidden' }} outline color="danger" onClick={() => this.deleteRecord(item.pk)}>Delete</Button></td>
                            </tr>
                            )) }
                    </tbody>
                </Table></div>
            </div>
        );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(Template);